import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {useAppSelector} from '@/hooks';
import type {AddItemOptions} from '@Panels/poster-add-items-panel/poster-add-items-panel';

interface AddItemModalProps {
  panelToShowOnOpen?: AddItemOptions;
}

const PANEL_ID = 'POSTER_ADD_ITEMS_PANEL_ID';

export default function PosterAddItemsModal(): ReactElement<any> {
  const [height, setHeight] = useState('638px');
  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });
  const bottomSheetCloseThreshold = useAppSelector((state) => {
    return state.panels.panelPropertiesHashmap[PANEL_ID]?.bottomSheetCloseThreshold;
  });
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.POSTER_EDITOR_ADD_ITEM_MODAL];
  });

  useEffect((): void => {
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  return (
    <Modal
      bottomSheetCloseThreshold={bottomSheetCloseThreshold}
      isBottomSheetOnMobile
      modalId={MODALS_IDS.POSTER_EDITOR_ADD_ITEM_MODAL}
      panelId={PANEL_ID}
      mobileHeight={height}
      modalHeight={height}
      modalWidth="100%"
    >
      <LazyPanel panelDirectoryName="poster-add-items-panel" panelProps={{...modalData.panelProps}} />
    </Modal>
  );
}

export const openPosterAddItemsModal = (props: AddItemModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ADD_ITEM_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        panelToShowOnOpen: props.panelToShowOnOpen,
      },
    })
  );
};
